import { SelectListItemRenderer } from '@acies/core';
import { Label, theme } from '@acies/ui';

export default class NameItemItemRenderer extends SelectListItemRenderer<{ name: string }> {
	#label!: Label;
	get #isFocused(): boolean {
		return this.state.toLowerCase().includes('focused');
	}

	public constructor() {
		super();
		this.cursor = 'pointer';
		this.alignment = 'left';
		this.height = 32;
		this.width = 'fill';
		this.paddingHorizontal = 8;
		this.cornerRadius = 6;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.label);
		this.updateStyles();
	}

	protected override selectedChanged(): void {
		super.selectedChanged();
		this.updateStyles();
	}

	protected override stateChanged(): void {
		super.stateChanged();
		this.updateStyles();
	}

	protected override itemChanged(): void {
		super.itemChanged();
		if (this.item) {
			this.label.text = this.item.name;
		}
	}

	private get label(): Label {
		if (!this.#label) {
			this.#label = new Label();
			this.#label.width = 'fill';
		}
		return this.#label;
	}

	protected updateStyles(): void {
		if (this.#isFocused) {
			this.updateFocusedStyles();
		} else if (this.selected) {
			this.updateSelectedStyles();
		} else {
			this.updateIdleStyles();
		}
	}

	protected updateFocusedStyles(): void {
		this.stroke = theme.strokes.focus_inside;
		this.fill = theme.colors.fill.focus;
	}

	protected updateIdleStyles(): void {
		this.stroke = null;
		this.fill = theme.colors.fill.white;
	}

	protected updateSelectedStyles(): void {
		this.stroke = null;
		this.fill = theme.colors.fill.selected;
	}
}
customElements.define('ac-featurelflags-name-item-renderer', NameItemItemRenderer);
